/**
 * Нотификации — короткие сообщения в правом верхнем углу.
 *
 * Раньше результат сохранения показывался строкой над формой: на длинной
 * форме параметров человек нажимал «Сохранить» внизу и не видел ответа
 * вовсе. Нотификация всегда на виду, поэтому подходит и для сохранения,
 * и для ошибок, и для остальных оповещений.
 *
 * Успех гаснет сам, ошибка ждёт, пока её закроют: сообщение об ошибке
 * человеку нужно прочитать, а иногда и переписать.
 */
const ICONS = {
    success: 'check-circle-fill',
    warning: 'alert-triangle-fill',
    error: 'alert-circle-fill',
    default: 'info-circle-fill',
};

// Успех держится дольше прочего: о том, что программа клиента собралась,
// эксперт узнаёт только отсюда, а пять секунд он пропускал, если смотрел
// в другую часть экрана (тест 08.10).
const AUTO_HIDE_MS = {
    success: 15000,
    default: 7000,
};

function container() {
    let node = document.querySelector('.notify');
    if (!node) {
        node = document.createElement('div');
        node.className = 'notify';
        document.body.appendChild(node);
    }
    return node;
}

function notify(text, type = 'success') {
    if (!text) return;
    const kind = ICONS[type] ? type : 'default';
    const card = document.createElement('div');
    card.className = `notify__item notify__item--${kind}`;

    // В нотификациях иконка всегда 20. В остальных местах берётся
    // вариант -small на 14: он не уменьшенная копия, а отдельная
    // отрисовка под малый размер (правило дизайн-системы 27.09).
    const size = 20;
    const icon = document.createElement('img');
    icon.src = `/img/icons/${ICONS[kind]}.svg`;
    icon.width = size;
    icon.height = size;
    icon.alt = '';
    icon.className = 'notify__icon';

    const message = document.createElement('p');
    message.className = 'notify__text';
    message.textContent = text;

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'notify__close';
    close.setAttribute('aria-label', 'Закрыть');
    // X.svg белый — он для тёмного фона; на сером кружке нужен тёмный.
    close.innerHTML = '<img src="/img/icons/X-dark.svg" alt="" width="20" height="20">';

    const remove = () => card.remove();
    close.addEventListener('click', remove);

    card.appendChild(icon);
    card.appendChild(message);
    card.appendChild(close);
    container().appendChild(card);

    const timeout = AUTO_HIDE_MS[kind];
    if (timeout) setTimeout(remove, timeout);
    return card;
}

export { notify };
